export default __webpack_public_path__ + "static/image10-aedd5b359d1cf8fcaa756c593b414883.gif";